import type { Attachment } from '@billy/design-system'

import { Bill } from '@features/bills/types/bill'
import type { IntegrationStatus } from '@features/bills/types/integrationStatus'

import type { ReceiptWithOwnerIntegrationStatus } from '../types/receiptWithOwnerIntegrationStatus'

export const isReceiptWithOwnerIntegrationStatus = (
  attachment: Attachment,
): attachment is ReceiptWithOwnerIntegrationStatus => 'owner' in attachment

export const getReceiptOwnerIntegrationStatuses = (attachment: Attachment): IntegrationStatus[] | undefined => {
  if (!isReceiptWithOwnerIntegrationStatus(attachment)) {
    return undefined
  }

  return attachment.owner?.integrationStatus
}

export const getReceiptBill = (attachment: Attachment): Bill | null => {
  if (!isReceiptWithOwnerIntegrationStatus(attachment)) {
    return null
  }

  return attachment.owner as Bill
}
